import { mockExperiences } from '../mocks/experiences';

export interface Experience {
  id: number;
  title: string;
  description: string;
  price: number;
  image: string;
  includes: string;
}

export const getExperiences = async (): Promise<Experience[]> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 0));
  return mockExperiences;
};

export const getExperienceById = async (id: number): Promise<Experience | undefined> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 0));
  return mockExperiences.find(experience => experience.id === id);
}; 